<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">Sublet Reversal Request List</div>
                    <div class="pagebutton">
                        <router-link class="themebutton" title="Add Sublet Reversal Request"
                            v-bind:to="{ name: 'AddUpdateSubletReversalForm' }">
                            <span>Add Sublet Reversal Request</span>
                        </router-link>
                        <a class="themebutton" style="margin-right: 5px; color: white;" id='exportAllSSubletReversalRequestId'
                            title='Export' v-on:click.prevent="exportSubletReversalRequestFunction(1)">
                            <span>Export</span>
                        </a>
                        <a class="themebutton" style="margin-right: 5px; color: white;" id='' :title='listName'
                            v-on:click.prevent="loadArchivedSubletReversalRequestList()">
                            <span>{{ listName }}</span>
                        </a>
                    </div>
                </div>
                <div class="clearfix"></div>
                <vue-good-table ref="SubletReversalRequestList" mode="remote" title="Sublet Reversal Request List"
                    @on-page-change="onPageChange" @on-selected-rows-change="selectionChanged"
                    @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" @on-sort-change="onSortChange"
                    :totalRows="totalRecords" :columns="columns" :rows="rows" :selectOptions="{
                            enabled: true,
                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                            selectionInfoClass: 'custom-class',
                            selectionText: 'rows selected',
                            clearSelectionText: 'clear',
                        }" :pagination-options="{
            enabled: true,
            mode: 'pages',
            pageLabel: 'Page',
            position: 'bottom',
            perPage: serverParams.perPage,
            setCurrentPage: serverParams.setCurrentPage,
            perPageDropdown: [25, 50, 100, 200, 500],
            dropdownAllowAll: false,
        }" :search-options="{
            enabled: false,
        }">
                    <!-- Custome Pagination -->
                    <template slot="pagination-bottom" slot-scope="props">
                        <div class="vgt-wrap__footer crm">
                            <div class="row">
                                <div class="col-sm-12 col-md-2 PerPage">
                                    <v-select title="Select Per Page" class="pagination-select-box"
                                        v-model="serverParams.perPage" @change="changedValueTask"
                                        @input="changedValueTaskCustomPerPageTask()" name="customPerPage" id="customPerPage"
                                        label="text" :clearable="false" :searchable="false" :filterable="false"
                                        :options="serverParams.perPageDropdown" placeholder="Select Per Page">
                                    </v-select>
                                </div>
                                <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                    <p class="pageRowCount">{{ paginationDisplayRowsTask }} of {{ totalRecords }}</p>
                                </div>
                                <div class="col-sm-12 col-md-6 Pagination">
                                    <ul class="pagination">
                                        <li class="FirstPage" title="First Page">
                                            <template v-if="Number(serverParams.page) == 1">
                                                <a class="page-link" href="javascript:void(0)">1</a>
                                            </template>
                                            <template v-else>
                                                <a v-on:click="onPerticularPageClickTask(1)" class="page-link"
                                                    href="javascript:void(0)">1</a>
                                            </template>
                                        </li>
                                        <li class="page-item PreviousPage" title="Previous Page">
                                            <template v-if="Number(serverParams.page) == 1">
                                                <a class="page-link" href="javascript:void(0)" tabindex="-1"><i
                                                        class="fa fa-angle-left"></i></a>
                                            </template>
                                            <template v-else>
                                                <a class="page-link" href="javascript:void(0)" tabindex="-1"
                                                    v-on:click="onPerticularPageClickTask(Number(serverParams.page) - 1)"><i
                                                        class="fa fa-angle-left"></i></a>
                                            </template>
                                        </li>
                                        <!--New Implementation-->
                                        <template v-if="pageNumberListTask() < displayPageTask">
                                            <template v-for="(n, index) in pageNumberListTask()">
                                                <li :title="'Page ' + n" class="PagesClass page-item active"
                                                    v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                    <a class="page-link" href="javascript:void(0)">
                                                        {{ n }}
                                                    </a>
                                                </li>
                                                <li :title="'Page ' + n" v-on:click="onPerticularPageClickTask(n)"
                                                    class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                    <a class="page-link" href="javascript:void(0)">
                                                        {{ n }}
                                                    </a>
                                                </li>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <!--End New Implementation-->
                                            <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                <template v-for="(n, index) in displayPageTask">
                                                    <li :title="'Page ' + n" class="PagesClass page-item active"
                                                        v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{ n }}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' + n" v-on:click="onPerticularPageClickTask(n)"
                                                        class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{ n }}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                            <template
                                                v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask - 1))">
                                                <template v-for="(n, index) in pageNumberListTask()">
                                                    <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                        <li :title="'Page ' + n" class="PagesClass page-item active"
                                                            v-bind:id="'pageNumber' + n"
                                                            v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{ n }}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' + n" v-on:click="onPerticularPageClickTask(n)"
                                                            class="PagesClass page-item" v-bind:id="'pageNumber' + n"
                                                            v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{ n }}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-for="(n, index) in pageNumberListTask()"
                                                    v-if="(n >= (Number(serverParams.page) - (pageCompareTask - 1))) && (n <= (Number(serverParams.page) + (pageCompareTask - 1)))">
                                                    <li :title="'Page ' + n" class="PagesClass page-item active"
                                                        v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{ n }}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' + n" v-on:click="onPerticularPageClickTask(n)"
                                                        class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{ n }}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                        </template>
                                        <li class="page-item NextPage" title="Next Page">
                                            <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                <a class="page-link" href="javascript:void(0)"><i
                                                        class="fa fa-angle-right"></i></a>
                                            </template>
                                            <template v-else>
                                                <a class="page-link" href="javascript:void(0)"
                                                    v-on:click="onPerticularPageClickTask(Number(serverParams.page) + 1)"><i
                                                        class="fa fa-angle-right"></i></a>
                                            </template>
                                        </li>
                                        <li class="LastPage" title="Last Page">
                                            <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                <a class="page-link" href="javascript:void(0)"
                                                    tabindex="-1">{{ pageNumberListTask() }}</a>
                                            </template>
                                            <template v-else>
                                                <a v-on:click="onPerticularPageClickTask(pageNumberListTask())"
                                                    class="page-link" href="javascript:void(0)"
                                                    tabindex="-1">{{ pageNumberListTask() }}</a>
                                            </template>
                                        </li>
                                    </ul>
                                </div>
                                <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                    <p class="pageJumpLabel">Page : </p>
                                </div>
                                <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                    <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text"
                                        class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask"
                                        placeholder="Page">
                                </div>
                            </div>
                        </div>
                    </template>
                    <!-- End Custome Pagination -->
                    <template slot="table-row" slot-scope="props" v-for="(row, key) in rows">
                        <div :key="key">
                            <div v-if="props.column.field == 'action'" class="table-action">
                                <router-link v-if="user_role == 1" title='Edit Sublet Reversal Request'
                                    class="btn edit-btn-vvg waves-effect pull-left"
                                    v-bind:to="{ name: 'UpdateSubletReversalForm', params: { id: props.row.id } }">
                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                </router-link>
                                <template v-if="!props.row.is_archive">
                                    <a href="javascript:void(0)"
                                        @click="archivedUnArchivedSubletReversalRequest(props.row.id, 1, 'Archive')"
                                        title='Archive' class="btn edit-btn-vvg waves-effect pull-left">
                                        <i class="fa fa-archive" aria-hidden="true"></i>
                                    </a>
                                </template>
                                <template v-else>
                                    <a href="javascript:void(0)"
                                        @click="archivedUnArchivedSubletReversalRequest(props.row.id, 0, 'Unarchive')"
                                        title='Unarchive' class="btn edit-btn-vvg waves-effect pull-left">
                                        <i class="fa fa-archive" aria-hidden="true"></i>
                                    </a>
                                </template>
                            </div>
                            <div v-else>
                                {{ props.formattedRow[props.column.field] }}
                            </div>
                        </div>
                    </template>
                    <div slot="selected-row-actions" slot-scope="computed">
                        {{ computed.selectedRows }}
                        <button id="exportSubletReversalRequestId" v-on:click.prevent="exportSubletReversalRequestFunction(0)"
                            class="btn btn-success" title="Export">
                            Export {{ selectedRows }} Record(s)
                        </button>
                        <template v-if="listName == 'Archived List'">
                            <button id="" v-on:click.prevent="archivedUnArchivedSubletReversalRequest(0, 1, 'Archive')"
                                class="btn btn-success" title="Archive">
                                Archived {{ selectedRows }} Record(s)
                            </button>
                        </template>
                        <template v-else>
                            <button id="" v-on:click.prevent="archivedUnArchivedSubletReversalRequest(0, 0, 'Unarchive')"
                                class="btn btn-success" title="Unarchive">
                                Unarchived {{ selectedRows }} Record(s)
                            </button>
                        </template>
                    </div>
                </vue-good-table>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Vue from 'vue';
import Footer from "@/components/partials/Footer";
import { commonMixins } from '../../../mixins/commonMixins';
import { HTTP } from '../../../http-common.js';
import VueGoodTable from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import EventBus from "../../../components/event-bus";
Vue.component("app-footer", Footer);
Vue.use(VueGoodTable);
var self;
export default {
    name: 'ListSubletReversalForm',
    components: {
    },
    mixins: [commonMixins],
    data() {
        return {
            firstLoad: 0,
            columns: [
                {
                    label: 'Employee Name',
                    field: 'empolyee_name',
                    filterable: true,
                    sortable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Employee Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Department Name',
                    field: 'department_name',
                    filterable: true,
                    sortable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Department Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Location Name',
                    field: 'location_name',
                    filterable: true,
                    sortable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Location Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Date Of Request',
                    field: 'date_of_request',
                    filterable: true,
                    sortable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "DD/MM/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Full Sublet',
                    field: 'full_sublet',
                    filterable: true,
                    sortable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Full Sublet", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Full RA',
                    field: 'full_ra',
                    filterable: true,
                    sortable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Full RA", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Reason Amendment',
                    field: 'reason_amendment',
                    filterable: true,
                    sortable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Reason Amendment", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Sublet Value',
                    field: 'sublet_value',
                    filterable: true,
                    sortable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Sublet Value", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Reason',
                    field: 'reason',
                    filterable: true,
                    sortable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Reason", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    filterable: true,
                    sortable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Comment',
                    field: 'comment',
                    filterable: true,
                    sortable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Comment", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                /* {
                    label: 'Question',
                    field: 'questions',
                    filterable: true,
                    sortable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Question", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Updated By',
                    field: 'updated_by',
                    filterable: true,
                    sortable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Updated By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                }, */
                {
                    label: 'Updated At',
                    field: 'updated_at',
                    filterable: true,
                    sortable: true,
                    filterOptions: {
                        // placeholder: "DD/MM/YYYY",
                        enabled: true, // enable filter for this column
                        placeholder: "DD/MM/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Actions',
                    field: 'action',
                    html: true,
                    sortable: false,
                    thClass: 'disable-sorting',
                    width: '108px',
                },
            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                page: 1,
                perPage: 25,
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                perPageDropdown: [],
            },
            displayPageTask: 7,
            jumpToPageTask: 0,
            pageCompareTask: 0,
            paginationDisplayRowsTask: '',
            exportSubletReversalRequest: false,
            isArchivedList: 0,
            listName: 'Archived List',
            loginUserRoleId: 1,
        }
    },
    watch: {
    },
    created: function () {
    },
    beforeMount: function () {
        self = this;
    },
    mounted: function () {
        self.menuActive("SubletReversalForm");
        self.jumpToPageTask = self.serverParams.page;
        self.pageCompareTask = Math.ceil(self.displayPageTask / 2);
        $("#jumpToPageTask").on('keyup', function (e) {
            if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                self.jumpToInputPageTask(self.jumpToPageTask)
            }
        });

        self.serverParams.perPageDropdown.push(25);
        self.serverParams.perPageDropdown.push(50);
        self.serverParams.perPageDropdown.push(100);
        self.serverParams.perPageDropdown.push(200);
        self.serverParams.perPageDropdown.push(500);
        self.loadSubletReversalRequest();
    },
    methods: {
        jumpToPageInTask: function (e) {
            self.jumpToInputPageTask(self.jumpToPageTask);
        },
        changedValueTaskCustomPerPageTask: function () {
            self.jumpToInputPageTask(self.serverParams.page);
            self.loadSubletReversalRequest();
        },
        changedValueTask: function (value) {
            /*console.log(value);*/
        },
        pageNumberListTask: function () {
            var totalRecord = self.totalRecords;
            var count = 0;
            for (var i = 0; totalRecord > 0; i++) {
                totalRecord = totalRecord - self.serverParams.perPage;
                count++;
            }
            return count;
        },
        jumpToInputPageTask: function (pageNumber) {
            var reg = /^\d+$/;
            if (pageNumber <= 0 || pageNumber == '') {
                pageNumber = 1;
            } else if (pageNumber > self.pageNumberListTask()) {
                pageNumber = self.pageNumberListTask();
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                }
            } else if (!String(self.jumpToPageTask).match(reg)) {
                pageNumber = 1;
            }
            self.onPerticularPageClickTask(pageNumber);
        },
        onPerticularPageClickTask: function (pageNumber) {
            self.serverParams.page = pageNumber;
            self.jumpToPageTask = pageNumber;
            self.loadSubletReversalRequest();
        },
        updateParams(newProps) {
            self.serverParams = Object.assign({}, self.serverParams, newProps);
        },
        onPageChange(params) {
            self.updateParams({ page: params.currentPage });
            self.loadSubletReversalRequest();
        },
        onPerPageChange(params) {
            if (params.currentPerPage != self.serverParams.perPage) {
                self.updateParams({ perPage: params.currentPerPage });
                self.totalRecords = self.totalRecords;
                self.loadSubletReversalRequest();
            }
        },
        onColumnFilter(params) {
            self.updateParams(params);
            {
                field: ('id');
                field: ('empolyee_name');
                field: ('date_of_request');
                field: ('full_sublet');
                field: ('full_ra');
                field: ('reason_amendment');
                field: ('sublet_value');
                field: ('reason');
                field: ('status');
                field: ('comment');
                field: ('updated_at');
                field: ('updated_by');
            };
            self.serverParams.page = 1;
            var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
            var filters = filtersPr.columnFilters;

            if (self.firstLoad == 1 || filters.id || filters.empolyee_name || filters.date_of_request  || filters.full_sublet || filters.full_ra
                || filters.reason_amendment || filters.sublet_value || filters.reason || filters.comment
                || filters.updated_at || filters.updated_by || filters.status
            ) {
                self.loadSubletReversalRequest();
            }
        },
        selectionChanged() {
            self.selectedRows = (self.$refs['SubletReversalRequestList'].selectedRows).length;
            /* console.log(self.selectedRows); */
        },
        onSortChange(params) {
            self.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
            self.loadSubletReversalRequest();
        },
        archivedUnArchivedSubletReversalRequest: function (id, state, flag) {
            let idArray = [];
            id = (id === null || typeof (id) === "undefined" || id == '' || id == 0) ? 0 : id;
            if (id != 0) {
                idArray.push(id);
            } else {
                var subletReversalListArr = [];
                var selectedSubletReversalRequest = this.$refs["SubletReversalRequestList"].selectedRows;
                for (var i = 0; i < selectedSubletReversalRequest.length; i++) {
                    subletReversalListArr.push(this.$refs["SubletReversalRequestList"].selectedRows[i].id);
                }
                idArray = subletReversalListArr;
            }
            self.$swal({
                title: '',
                text: 'Are you sure that you want to ' + flag + ' this Sublet Reversal Request(s)!',
                type: 'info',
                confirmButtonText: 'OK',
                showCancelButton: true,
                // showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    var config = {
                        headers: { Authorization: "Bearer " + localStorage.getItem("token") },

                    };
                    var fields = {
                        idArray: idArray,
                        state: state,
                        flag: flag,
                    };
                    HTTP.post("/sublet-reversal-request/archive/unarchive", fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.loadSubletReversalRequest();
                            }
                        })
                        .catch(function (error) {
                            self.catchHandler(err, function () { });
                        });
                }
            });
        },
        loadArchivedSubletReversalRequestList: function () {
            self.isArchivedList = self.isArchivedList ? 0 : 1;
            self.listName = (self.isArchivedList) ? 'Unarchived List' : 'Archived List';
            self.loadSubletReversalRequest();
        },
        loadSubletReversalRequest() {
            self.firstLoad = 1;
            var config = {
                headers: { Authorization: "Bearer " + localStorage.getItem("token") },
            };
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                is_export: self.exportSubletReversalRequest,
                is_archived_list: self.isArchivedList,
            };
            self.showLoader();
            HTTP.post("/sublet-reversal-request/list", fields, config)
                .then(function (response) {
                    $('#exportAllSSubletReversalRequestId').prop("disabled", false);
                    self.exportSubletReversalRequest = false;
                    if (response.data.code == '200') {
                        if (response.data.message == 'success export') {
                            self.downloadFile(response.data.content.web);
                            // location.href = response.data.content.web;
                            self.loadSubletReversalRequest();
                        } else {
                            self.rows = response.data.content.row;
                            self.totalRecords = response.data.content.totalRecords;
                            self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                        }
                    }
                    self.hideLoader();
                })
                .catch(function (err) {
                    $('#exportAllSSubletReversalRequestId').prop("disabled", false);
                    self.exportSubletReversalRequest = false;
                    self.hideLoader();
                    self.catchHandler(err, function () { });
                });
        },
        exportSubletReversalRequestFunction: function (allResersalDataExport) {
            if (allResersalDataExport) {
                self.exportSubletReversalRequest = true;
                if (self.exportSubletReversalRequest == true) {
                    $('#exportAllSSubletReversalRequestId').prop("disabled", true);
                    self.loadSubletReversalRequest();
                }
            } else {
                var reversalArr = [];
                var selectedUser = this.$refs["SubletReversalRequestList"].selectedRows;
                for (var i = 0; i < selectedUser.length; i++) {
                    reversalArr.push(this.$refs["SubletReversalRequestList"].selectedRows[i].id);
                }
                $('#exportSubletReversalRequestId').prop("disabled", true);
                var config = {
                    headers: { Authorization: "Bearer " + localStorage.getItem("token") },
                };
                var fields = {
                    reversal_id_arr: reversalArr
                };
                self.showLoader();
                HTTP.post("/sublet-reversal-request/export", fields, config)
                    .then(function (response) {
                        $('#exportSubletReversalRequestId').prop("disabled", false);
                        if (response.data.code == '200') {
                            self.downloadFile(response.data.content.web);
                            // location.href = response.data.content.web;
                            self.loadSubletReversalRequest();
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        $('#exportSubletReversalRequestId').prop("disabled", false);
                        self.hideLoader();
                        self.catchHandler(err, function () { });
                    });
            }
        },
    },
};
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/Forms/SubletReversalForm/ListSubletReversalForm.vue